import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { supOrgCustomTripMnBookingFn, supOrgMnBookingFun } from '../../../api/supportAdmin';
import { trnOptions } from '../addBooking/constants/TripBookingConstant';

export default async function addBoMuBook({ muBookData, tripDateId, setAddBo, setLoading, refresh, packData }) {
    //check weather the data was entred in all the fields and
    //check the quality of the date entered
    //Send the date to backend and get back updated table back
    //or fetch the new data table from backend and update the table
    //Show notifaction of the status of adding new Booking

    if (packData?.contentId?.group === 'vehicle' && packData?.contentId?.datesType === 'fixed') {
        if (!muBookData.startCity) {
            toast.error('Select Start City');
            return;
        } else if (!muBookData.meetupPoint) {
            toast.error('Select meetupPoint');
            return;
        } else if (!muBookData.transport) {
            toast.error('Select Transport');
            return;
        } else if (muBookData.amountPaid.paid <= 0) {
            toast.error('Please enter the paid amount');
            return;
        } else if (!muBookData.userDetails || muBookData.userDetails.length === 0) {
            toast.error('Add at least one user detail');
            return;
        }
    } else {
        if (!muBookData.startCity) {
            toast.error('Select Start City');
            return;
        } else if (!muBookData.pickupLocation) {
            toast.error('Select Pickup Location');
            return;
        } else if (muBookData.amountPaid.paid <= 0) {
            toast.error('Please enter the paid amount');
            return;
        } else if (!muBookData.userDetails || muBookData.userDetails.length === 0) {
            toast.error('Add at least one user detail');
            return;
        }
    }

    const isUserDetailsValid = muBookData.userDetails.every((user, index) => {
        if (!user.name || 3 > user.name.length || user.name.length > 30) {
            toast.error(`User ${index + 1}: Name is required`);
            return false;
        } else if (!user.age) {
            toast.error(`User ${index + 1}: Age is required`);
            return false;
        } else if (!user.sex) {
            toast.error(`User ${index + 1}: Sex is required`);
            return false;
        } else if (!user.phoneNumber) {
            toast.error(`User ${index + 1}: Phone Number is required`);
            return false;
        } else if (!user.emailId) {
            toast.error(`User ${index + 1}: Email ID is required`);
            return false;
        }
        return true;
    });

    if (!isUserDetailsValid) {
        return;
    }
    setLoading(true);

    try {
        let response;
        if (packData?.contentId?.datesType === 'custom' || packData.datesType === 'custom') {
            const reservePricePerPerson = packData?.price?.[0].customPrice?.reserve;
            const updatedData = {
                ...muBookData,
                amountPaid: { ...muBookData.amountPaid, reserve: reservePricePerPerson }
            };
            response = await supOrgCustomTripMnBookingFn(updatedData);
        } else {
            const specialReservePrice = packData?.price?.reserve;
            const reservePricePerPerson =
                specialReservePrice > 0 ? specialReservePrice : packData?.contentId?.price[0]?.price?.reserve;
            const updatedData = {
                ...muBookData,
                transport: muBookData.transport === '' ? trnOptions[0] : muBookData.transport,
                amountPaid: { ...muBookData.amountPaid, reserve: reservePricePerPerson },
                pickupLocation: muBookData.meetupPoint || muBookData.pickupLocation
            };
            response = await supOrgMnBookingFun(updatedData);
        }

        if (response.status === 200) {
            toast.success(`Booked Successfully`);
            setAddBo(false);
            refresh();
        }
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
